import { render, staticRenderFns } from "./hotelManageOrderInfo.vue?vue&type=template&id=6685b754&scoped=true&"
import script from "./hotelManageOrderInfo.vue?vue&type=script&lang=js&"
export * from "./hotelManageOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./hotelManageOrderInfo.vue?vue&type=style&index=0&id=6685b754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685b754",
  null
  
)

export default component.exports